<template>
    <!-- 模板部分保持不变 -->
    <div class="about bg-white">
        <!-- 页面横幅 -->
        <section class="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] py-20 text-white">
            <div class="max-w-[1200px] mx-auto px-4 flex items-center justify-between">
                <div class="max-w-2xl">
                    <h2 class="text-4xl font-bold mb-6">共建数据智能生态</h2>
                    <p class="text-xl text-blue-100 leading-relaxed opacity-90">
                        携手行业伙伴，共创数据资产化解决方案，赋能企业数字化转型，共享数据智能时代新机遇。
                    </p>
                </div>
                <div class="hidden lg:block">
                    <span class="iconify text-[160px] text-white/20" data-icon="ri:handshake-line"></span>
                </div>
            </div>
        </section>
        <!-- 主体内容区 -->
        <section class="max-w-[1200px] mx-auto px-4 py-16 ">
            <div class="flex flex-col lg:flex-row gap-16">
                <!-- 左侧：联系表单 -->
                <div class="w-full lg:w-3/5 bg-white p-10 rounded-2xl shadow-sm border border-gray-100">
                    <h3 class="text-2xl font-bold mb-8 flex items-center">
                        <span class="iconify mr-3 text-[#0052CC]" data-icon="solar:pen-new-square-linear"></span>
                        合作申请
                    </h3>
                    <form class="space-y-6" @submit.prevent="handleSubmit">
                        <div class="grid grid-cols-2 gap-6">
                            <div class="space-y-2">
                                <label class="text-sm font-medium text-[#4B5563]">您的姓名 <span
                                        style="color: red;">*</span></label>
                                <input v-model="formData.name" :class="[
                                    'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                    validationErrors.name ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                                ]" placeholder="请输入姓名" type="text" @input="clearFieldError('name')" />
                                <div v-if="validationErrors.name" class="text-red-500 text-sm mt-1 flex items-center">
                                    <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                    {{ validationErrors.name }}
                                </div>
                            </div>
                            <div class="space-y-2">
                                <label class="text-sm font-medium text-[#4B5563]">所属公司/机构 <span
                                        style="color: red;">*</span></label>
                                <input v-model="formData.company" :class="[
                                    'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                    validationErrors.company ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                                ]" placeholder="请输入单位全称" type="text" @input="clearFieldError('company')" />
                                <div v-if="validationErrors.company"
                                    class="text-red-500 text-sm mt-1 flex items-center">
                                    <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                    {{ validationErrors.company }}
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-2 gap-6">
                            <div class="space-y-2">
                                <label class="text-sm font-medium text-[#4B5563]">邮箱地址 <span
                                        style="color: red;">*</span></label>
                                <input v-model="formData.email" :class="[
                                    'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                    validationErrors.email ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                                ]" placeholder="example@domain.com" type="text" @input="clearFieldError('email')" />
                                <div v-if="validationErrors.email" class="text-red-500 text-sm mt-1 flex items-center">
                                    <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                    {{ validationErrors.email }}
                                </div>
                            </div>
                            <div class="space-y-2">
                                <label class="text-sm font-medium text-[#4B5563]">联系电话</label>
                                <input v-model="formData.phone" :class="[
                                    'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                    validationErrors.phone ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                                ]" placeholder="请输入联系电话" type="tel" @input="clearFieldError('phone')" />
                                <div v-if="validationErrors.phone" class="text-red-500 text-sm mt-1 flex items-center">
                                    <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                    {{ validationErrors.phone }}
                                </div>
                            </div>
                        </div>

                        <div class="space-y-2">
                            <label class="text-sm font-medium text-[#4B5563]">其他联系方式</label>
                            <input v-model="formData.otherContact" :class="[
                                'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                validationErrors.otherContact ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                            ]" placeholder="如微信、QQ等其他联系方式" type="text" @input="clearFieldError('otherContact')" />
                            <div v-if="validationErrors.otherContact"
                                class="text-red-500 text-sm mt-1 flex items-center">
                                <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                {{ validationErrors.otherContact }}
                            </div>
                        </div>
                        <div class="space-y-2">
                            <label class="text-sm font-medium text-[#4B5563]">需求类别</label>
                            <div class="flex gap-4">
                                <label class="flex items-center space-x-2 cursor-pointer">
                                    <input v-model="formData.type" value="business" class="w-4 h-4 text-[#0052CC]"
                                        type="radio" />
                                    <span class="text-sm">商务合作</span>
                                </label>
                                <label class="flex items-center space-x-2 cursor-pointer">
                                    <input v-model="formData.type" value="academic" class="w-4 h-4 text-[#0052CC]"
                                        type="radio" />
                                    <span class="text-sm">学术咨询</span>
                                </label>
                                <label class="flex items-center space-x-2 cursor-pointer">
                                    <input v-model="formData.type" value="media" class="w-4 h-4 text-[#0052CC]"
                                        type="radio" />
                                    <span class="text-sm">媒体采访</span>
                                </label>
                            </div>
                        </div>
                        <div class="space-y-2">
                            <label class="text-sm font-medium text-[#4B5563]">留言内容 <span
                                    style="color: red;">*</span></label>
                            <textarea v-model="formData.message" :class="[
                                'w-full px-4 py-3 bg-[#F9FAFB] border rounded-lg focus:ring-4 focus:ring-[#0052CC]/10 outline-none transition-all',
                                validationErrors.message ? 'border-red-500 focus:border-red-500' : 'border-gray-200 focus:border-[#0052CC]'
                            ]" placeholder="请详细描述您的需求或问题" rows="5" @input="clearFieldError('message')"></textarea>
                            <div v-if="validationErrors.message" class="text-red-500 text-sm mt-1 flex items-center">
                                <span class="iconify mr-1" data-icon="mdi:alert-circle-outline"></span>
                                {{ validationErrors.message }}
                            </div>
                        </div>
                        <button type="submit" @click="handleSubmit"
                            class="w-full bg-[#0052CC] text-white py-4 rounded-lg font-bold hover:bg-[#003D99] transition-all shadow-lg shadow-blue-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
                            :disabled="isSubmitDisabled" :class="{
                                'bg-green-600 hover:bg-green-700': isSubmitted && !hasFormChanged,
                                'bg-[#0052CC] hover:bg-[#003D99]': !isSubmitted || hasFormChanged
                            }">
                            {{ submitButtonText }}
                        </button>
                    </form>
                </div>

                <!-- 右侧：详细信息与地图 -->
                <div class="w-full lg:w-2/5 space-y-10">


                    <div class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                        <h3 class="text-xl font-bold mb-6">联系方式</h3>
                        <div class="space-y-6">
                            <div class="flex gap-4">
                                <div
                                    class="w-10 h-10 bg-blue-50 text-[#0052CC] rounded-full flex items-center justify-center shrink-0">
                                    <span class="iconify" data-icon="solar:map-point-bold"></span>
                                </div>
                                <div>
                                    <p class="text-xs text-[#6B7280] font-bold uppercase tracking-wider mb-1">办公地址</p>
                                    <p class="text-[#1F2937]">河北省保定市竞秀区东风路联通公司2号办公楼17层</p>
                                </div>
                            </div>
                            <div class="flex gap-4">
                                <div
                                    class="w-10 h-10 bg-indigo-50 text-[#4F46E5] rounded-full flex items-center justify-center shrink-0">
                                    <span class="iconify" data-icon="solar:phone-bold"></span>
                                </div>
                                <div>
                                    <p class="text-xs text-[#6B7280] font-bold uppercase tracking-wider mb-1">联系电话</p>
                                    <p class="text-[#1F2937]">15831289727</p>
                                </div>
                            </div>
                            <div class="flex gap-4">
                                <div
                                    class="w-10 h-10 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center shrink-0">
                                    <span class="iconify" data-icon="solar:letter-bold"></span>
                                </div>
                                <div>
                                    <p class="text-xs text-[#6B7280] font-bold uppercase tracking-wider mb-1">电子邮箱</p>
                                    <p class="text-[#1F2937]">yuanshuqiang@xinxiusz.com</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 腾讯地图 -->
                    <div class="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
                        <div class="p-4 border-b border-gray-100">
                            <h3 class="text-lg font-bold flex items-center">
                                <span class="iconify mr-2 text-[#0052CC]" data-icon="solar:map-point-bold"></span>
                                地理位置
                            </h3>
                        </div>
                        <!-- 地图容器 -->
                        <div id="tencent-map" class="h-[300px] w-full">
                            <!-- 地图加载中提示 -->
                            <div v-if="!mapLoaded && !mapError"
                                class="h-full flex items-center justify-center bg-gray-50">
                                <div class="text-center">
                                    <div
                                        class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2">
                                    </div>
                                    <p class="text-gray-500 text-sm">地图加载中...</p>
                                </div>
                            </div>

                            <!-- 静态地图图片（备用） -->
                            <div v-if="mapError" class="h-full w-full relative">
                                <img :src="staticMapImage" alt="机构位置地图"
                                    class="w-full h-full object-cover rounded-b-xl" />
                                <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                <div class="absolute bottom-4 left-4 right-4">
                                    <div class="bg-white/90 backdrop-blur-sm rounded-lg p-4 shadow-lg">
                                        <p class="text-sm text-gray-700 font-medium">
                                            <span class="iconify inline mr-2 text-blue-600"
                                                data-icon="solar:map-point-bold"></span>
                                            河北省保定市竞秀区东风路联通公司2号办公楼17层
                                        </p>
                                        <button @click="loadTencentMapAPI"
                                            class="mt-2 px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors">
                                            尝试重新加载地图
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-4 bg-gray-50 border-t border-gray-100">
                            <p class="text-sm text-gray-600">
                                <span class="iconify inline mr-1 text-gray-500"
                                    data-icon="solar:info-circle-bold"></span>
                                地址：河北省保定市竞秀区东风路联通公司2号办公楼17层
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 提交成功提示 -->
        <div v-if="showSuccessToast" class="fixed top-6 right-6 z-50 animate-slide-in">
            <div class="bg-green-50 border border-green-200 rounded-xl p-4 shadow-lg flex items-center space-x-3">
                <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <span class="iconify text-xl" data-icon="ri:checkbox-circle-fill"></span>
                </div>
                <div>
                    <p class="font-medium text-green-800">提交成功！</p>
                    <p class="text-sm text-green-600">我们将尽快与您联系</p>
                </div>
            </div>
        </div>

        <!-- 本地提示组件 -->
        <!-- <ToastNotification v-if="showToast" ref="toastRef" :type="toastType" :message="toastMessage" :duration="3000"
            @close="showToast = false" /> -->
    </div>
</template>

<script>
export default {
    name: 'WebsiteAbout',

    // components: {
    //     ToastNotification
    // },

    data() {
        return {
            // 图片相关
            imgBaseUrl: process.env.VITE_APP_IMG_BASE || '',

            // 表单数据
            formData: {
                name: '',
                company: '',
                email: '',
                phone: '',
                otherContact: '',
                type: 'business',
                message: ''
            },

            // 验证错误
            validationErrors: {},

            // 提交状态
            isSubmitting: false,

            // 提示相关
            showToast: false,
            toastType: 'success',
            toastMessage: '',
            // 提交成功提示
            showSuccessToast: false,

            // 地图相关
            mapInstance: null,
            mapLoaded: false,
            mapError: false,

            // 研究院坐标
            instituteLocation: {
                lng: 115.463610,
                lat: 38.873093
            },

            // 记录初始表单数据
            initialFormData: null,
            // 提交状态
            isSubmitted: false,

            // 数字人相关
            dhConfigVisible: false,
            dhModalVisible: false,
            dhIframeSrc: '',
            dhAvatarId: '',
            dhAspect: '9:16',
            dhIniting: false,
            dhErrorMsg: '',
            dhCountdownSec: 0,
            _dhTimer: null,
            dhCoverVisible: false,
            dhCoverDelay: 3000,
            _onUnhandledRejection: null,
        }
    },

    computed: {
        doorImg() {
            return this.imgBaseUrl + '/door.jpg'
        },

        staticMapImage() {
            const { lat, lng } = this.instituteLocation
            return `https://apis.map.qq.com/ws/staticmap/v2/?center=${lat},${lng}&zoom=16&size=600x300&markers=icon:https://mapapi.qq.com/web/lbs/javascriptV2/demo/img/center.png|${lat},${lng}&key=PVVBZ-TPBCF-DKYJ4-JBZED-AFICS-YNFRZ`
        },

        // 检查表单是否有改动
        hasFormChanged() {
            if (!this.initialFormData) return false

            return Object.keys(this.formData).some(key => {
                return this.formData[key] !== this.initialFormData[key]
            })
        },

        // 按钮文本
        submitButtonText() {
            if (this.isSubmitting) return '提交中...'
            if (this.isSubmitted && !this.hasFormChanged) return '已提交'
            return '提 交'
        },

        // 按钮是否禁用
        isSubmitDisabled() {
            return this.isSubmitting || (this.isSubmitted && !this.hasFormChanged)
        },

        dhModalStyle() {
            const [w, h] = this.dhAspect.split(':').map(Number)
            return { width: w > h ? 'min(960px, 92vw)' : 'min(380px, 90vw)' }
        },
        dhBodyStyle() {
            const [w, h] = this.dhAspect.split(':').map(Number)
            return { aspectRatio: `${w} / ${h}`, maxHeight: 'calc(92vh - 66px)' }
        },
        dhCountdownDisplay() {
            const m = Math.floor(this.dhCountdownSec / 60)
            const s = this.dhCountdownSec % 60
            return `${m}:${String(s).padStart(2, '0')}`
        },
    },

    mounted() {
        this.loadTencentMapAPI()
        this.saveInitialFormData()
        this._onUnhandledRejection = (e) => {
            if (e.reason && e.reason.message && e.reason.message.includes("play")) {
                e.preventDefault()
            }
        }
        window.addEventListener('unhandledrejection', this._onUnhandledRejection)
    },

    beforeDestroy() {
        if (this.mapInstance) {
            this.mapInstance = null
        }
        window.removeEventListener('message', this._onDhMessage)
        window.removeEventListener('unhandledrejection', this._onUnhandledRejection)
        this._stopCountdown()
    },
    methods: {
        // 保存初始表单数据
        saveInitialFormData() {
            this.initialFormData = JSON.parse(JSON.stringify(this.formData))
        },

        // 获取当前时间（新增方法）
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 清除单个字段的错误信息
        clearFieldError(field) {
            if (this.validationErrors[field]) {
                const newErrors = { ...this.validationErrors }
                delete newErrors[field]
                this.validationErrors = newErrors
            }
            // 如果字段有改动，重置提交状态
            if (this.initialFormData && this.formData[field] !== this.initialFormData[field]) {
                this.resetSubmitState()
            }
        },

        // 表单验证函数
        validateForm() {
            const errors = {}

            if (!this.formData.name.trim()) {
                errors.name = '请输入您的姓名'
            }

            if (!this.formData.company.trim()) {
                errors.company = '请输入所属公司/机构'
            }

            if (!this.formData.email.trim()) {
                errors.email = '请输入邮箱地址'
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
                errors.email = '请输入有效的邮箱地址'
            }

            // 电话号码验证（可选）
            if (this.formData.phone.trim() && !/^1[3-9]\d{9}$/.test(this.formData.phone)) {
                errors.phone = '请输入有效的手机号码'
            }
            if (this.formData.otherContact.trim() && this.formData.otherContact.length > 100) {
                errors.otherContact = '其他联系方式不能超过100个字符'
            }


            if (!this.formData.message.trim()) {
                errors.message = '请输入留言内容'
            }

            this.validationErrors = errors

            // 如果有错误，滚动到第一个错误字段
            if (Object.keys(errors).length > 0) {
                this.$nextTick(() => {
                    const firstErrorField = Object.keys(errors)[0]
                    const errorElement = document.querySelector(`[v-model="formData.${firstErrorField}"]`)
                    if (errorElement) {
                        errorElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        })
                        errorElement.focus()
                    }
                })
                return false
            }

            return true
        },

        // 表单提交处理
        async handleSubmit() {
            if (this.isSubmitting || this.isSubmitDisabled) return;


            // 先进行表单验证
            if (!this.validateForm()) {
                return;
            }

            this.isSubmitting = true;

            try {

                const consultationData = {
                    name: this.formData.name,
                    contact: `邮箱：${this.formData.email}, 手机：${this.formData.phone}, 其他联系方式：${this.formData.otherContact}`,
                    problemDescription: this.formData.message,
                    subjectName: this.formData.company || '未填写',
                    consultationTime: this.getCurrentTime(),
                    status: 0 // 默认未处理
                };

                console.log('提交咨询请求参数:', consultationData);

                // 调用API接口
                const response = await this.$axios.post('/web/consultation/save', consultationData);
                console.log('提交咨询响应:', response.data);

                if (response.data && response.data.status === 200) {
                    // 显示成功提示
                    this.showSuccessToast = true;

                    // 设置提交状态
                    this.isSubmitted = true;

                    // 更新初始表单数据为当前提交的数据
                    this.saveInitialFormData();

                    // 重置表单
                    // this.formData = {
                    //     name: '',
                    //     company: '',
                    //     email: '',
                    //     phone: '',
                    //     otherContact: '',
                    //     type: 'business',
                    //     message: ''
                    // };
                    this.validationErrors = {};
                    // 3秒后自动隐藏成功提示
                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);

                } else {
                    this.showToastMessage('error', response.data?.msg || '提交咨询失败');
                }

            } catch (error) {
                console.error('提交咨询失败:', error);
                this.showToastMessage('error', '提交咨询失败，请稍后重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 显示提示的方法
        showToastMessage(type, message) {
            this.toastType = type
            this.toastMessage = message
            this.showToast = true

            // 3秒后自动隐藏
            setTimeout(() => {
                this.showToast = false
            }, 3000)
        },

        // 初始化腾讯地图 - 简化版本
        initTencentMap() {
            try {
                // 检查腾讯地图API是否加载
                if (typeof window === 'undefined') {
                    this.mapError = true
                    return
                }

                // 腾讯地图的全局对象可能是 TMap 或 qq.maps
                const TMap = window.TMap

                if (!TMap) {
                    console.error('腾讯地图API未加载')
                    this.mapError = true
                    return
                }

                // 获取地图容器
                const mapContainer = document.getElementById('tencent-map')
                if (!mapContainer) {
                    console.error('地图容器未找到')
                    this.mapError = true
                    return
                }

                // 创建地图实例
                const map = new TMap.Map(mapContainer, {
                    center: new TMap.LatLng(this.instituteLocation.lat, this.instituteLocation.lng),
                    zoom: 17,
                    viewMode: '2D',
                    baseMap: {
                        type: 'vector'
                    }
                })

                // 添加标记
                const marker = new TMap.MultiMarker({
                    map: map,
                    geometries: [{
                        id: 'institute',
                        position: new TMap.LatLng(this.instituteLocation.lat, this.instituteLocation.lng),
                        content: ''
                    }]
                })

                // 添加信息窗口
                const infoWindow = new TMap.InfoWindow({
                    map: map,
                    position: new TMap.LatLng(this.instituteLocation.lat, this.instituteLocation.lng),
                    content: `
                        <div style="
                            padding: 12px;
                            max-width: 220px;
                            background: white;
                            border-radius: 8px;
                            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                        ">
                            <h4 style="
                                margin: 0 0 8px 0;
                                color: #0052CC;
                                font-weight: bold;
                                font-size: 14px;
                            ">
                                企服数据要素研究院
                            </h4>
                        </div>
                    `,
                    visible: false
                })

                // 点击标记显示信息窗口
                marker.on('click', (evt) => {
                    if (evt.geometry?.id === 'institute') {
                        infoWindow.open()
                    }
                })

                // 添加基本控件（如果有的话）
                try {
                    if (TMap.Control && TMap.Control.Scale) {
                        map.addControl(new TMap.Control.Scale())
                    }
                    if (TMap.Control && TMap.Control.Zoom) {
                        map.addControl(new TMap.Control.Zoom())
                    }
                } catch (error) {
                    console.warn('地图控件添加失败:', error)
                }

                this.mapInstance = map
                this.mapLoaded = true
                this.mapError = false

            } catch (error) {
                console.error('腾讯地图初始化失败:', error)
                this.mapError = true
            }
        },

        // 数字人相关方法
        openDhConfig() {
            this.dhErrorMsg = ''
            this.dhConfigVisible = true
        },
        closeDhConfig() {
            this.dhConfigVisible = false
        },
        async initAndOpenDh() {
            if (!this.dhAvatarId) return
            this.dhIniting = true
            try {
                // 1. 校验数字人ID
                const verifyRes = await this.$axios.get('/web/digitalHuman/verify', {
                    params: { avatarId: this.dhAvatarId }
                })
                if (!verifyRes.data || verifyRes.data.status !== 200) {
                    this.dhErrorMsg = verifyRes.data?.msg || '数字人ID无效，请确认后重试'
                    this.dhIniting = false
                    return
                }
                this.dhErrorMsg = ''

                // sliceTime 单位秒，SDK 读的是毫秒
                const sliceTime = verifyRes.data?.object?.sliceTime || 0
                localStorage.setItem('sliceTime', sliceTime > 0 ? sliceTime * 1000 : 0)

                // coverDelay 单位毫秒
                this.dhCoverDelay = verifyRes.data?.object?.coverDelay || 3000

                // 2. 加载SDK + 获取Token
                await this.loadDhScript('/sdk/npcTalkFloatingButton.js')
                const apiKey = process.env.VUE_APP_NUWA_API_KEY
                const res = await fetch('https://api.nuwaai.com/web/apiKey/auth', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secretKey: apiKey })
                })
                const data = await res.json()
                if (data.code === 0) {
                    localStorage.setItem('token', data.data)
                }
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                    stream.getTracks().forEach(t => t.stop())
                } catch (e) {
                    console.warn('麦克风授权失败:', e.message)
                }
                const userId = process.env.VUE_APP_NUWA_USER_ID || '83552'
                localStorage.setItem('backAddress', '')
                localStorage.setItem('sdkPageTitle', '智能客服')
                this.dhIframeSrc = `/sdk/index-sdk.html?id=${this.dhAvatarId}&userId=${userId}`
                this.dhCoverVisible = true
                this.dhConfigVisible = false
                this.dhModalVisible = true
                window.addEventListener('message', this._onDhMessage)
                this._startCountdown(sliceTime)
            } catch (e) {
                this.dhErrorMsg = '初始化失败，请稍后重试'
            } finally {
                this.dhIniting = false
            }
        },
        closeDh() {
            this.dhModalVisible = false
            this.dhIframeSrc = ''
            this.dhVideoUrl = ''
            this._stopCountdown()
            window.removeEventListener('message', this._onDhMessage)
        },

        _startCountdown(totalSec) {
            this._stopCountdown()
            if (!totalSec || totalSec <= 0) {
                this.dhCountdownSec = 0
                return
            }
            this.dhCountdownSec = totalSec
            this._dhTimer = setInterval(() => {
                this.dhCountdownSec--
                if (this.dhCountdownSec <= 0) {
                    this.closeDh()
                }
            }, 1000)
        },

        _stopCountdown() {
            if (this._dhTimer) {
                clearInterval(this._dhTimer)
                this._dhTimer = null
            }
            this.dhCountdownSec = 0
        },
        _onDhMessage(e) {
            if (e.data && (e.data.type === 'back' || e.data.type === 'close' || e.data === 'back')) {
                this.closeDh()
            }
            if (e.data && e.data.type === 'dh_ready') {
                setTimeout(() => { this.dhCoverVisible = false }, 2000)
            }
        },
        onIframeLoad() {
            try {
                const iframeWin = this.$refs.dhIframe.contentWindow
                Object.defineProperty(iframeWin.location, 'href', {
                    set: () => { this.closeDh() },
                    configurable: true
                })
            } catch (e) {}
        },
        _waitForDhReady() {},
        loadDhScript(src) {
            return new Promise((resolve, reject) => {
                if (document.querySelector(`script[src="${src}"]`)) { resolve(); return }
                const script = document.createElement('script')
                script.src = src
                script.onload = resolve
                script.onerror = reject
                document.head.appendChild(script)
            })
        },

        // 加载腾讯地图API
        loadTencentMapAPI() {            // 检查是否已加载
            if (typeof window.TMap !== 'undefined') {
                console.log('腾讯地图API已加载')
                this.initTencentMap()
                return
            }

            // 创建script标签加载腾讯地图API
            const script = document.createElement('script')
            script.src = `https://map.qq.com/api/gljs?v=2.exp&key=PVVBZ-TPBCF-DKYJ4-JBZED-AFICS-YNFRZ`
            script.async = true
            script.defer = true

            script.onload = () => {
                console.log('腾讯地图API加载成功')
                // 等待一小段时间确保API完全初始化
                setTimeout(() => {
                    this.initTencentMap()
                }, 100)
            }

            script.onerror = (error) => {
                console.error('腾讯地图API加载失败:', error)
                this.mapError = true
            }

            document.head.appendChild(script)
        }
    }
}
</script>

<style scoped>
/* 地图容器样式 */
#tencent-map {
    border-radius: 0 0 1rem 1rem;
    position: relative;
    overflow: hidden;
}

/* 地图加载动画 */
.animate-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 地图标记动画 */
@keyframes markerBounce {
    0% {
        transform: translateY(-20px) scale(0.8);
        opacity: 0;
    }

    50% {
        transform: translateY(5px) scale(1.1);
    }

    100% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

/* 腾讯地图标记样式 */
.tencent-map-marker {
    animation: markerBounce 0.6s ease-out;
}

/* 静态地图图片样式 */
.static-map-image {
    filter: brightness(0.95);
    transition: filter 0.3s ease;
}

.static-map-image:hover {
    filter: brightness(1);
}

/* 添加验证相关的动画效果 */
input,
textarea {
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

/* 错误状态下的输入框样式 */
input:focus.border-red-500,
textarea:focus.border-red-500 {
    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

/* 验证错误提示的动画 */
.text-red-500 {
    animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}



/* 添加成功提示的动画 */
.animate-slide-in {
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 数字人入口卡片 */
.digital-human-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    background: linear-gradient(135deg, #0D47A1 0%, #1976D2 60%, #42A5F5 100%);
    border-radius: 16px;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    box-shadow: 0 8px 24px rgba(13, 71, 161, 0.35);
}

.digital-human-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 32px rgba(13, 71, 161, 0.45);
}

.dh-bg-glow {
    position: absolute;
    top: -40px;
    right: -40px;
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    pointer-events: none;
}

.dh-avatar {
    position: relative;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-avatar-icon {
    font-size: 30px;
    color: #fff;
}

.dh-pulse-ring {
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    animation: dh-pulse 2s ease-out infinite;
}

@keyframes dh-pulse {
    0%   { transform: scale(1); opacity: 0.7; }
    100% { transform: scale(1.5); opacity: 0; }
}

.dh-info {
    flex: 1;
    min-width: 0;
}

.dh-title {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 4px;
}

.dh-desc {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 10px;
}

.dh-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.dh-tag {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 20px;
    padding: 2px 10px;
}

.dh-hint {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 11px;
    font-weight: 600;
    text-align: center;
    line-height: 1.4;
}

.dh-hint .iconify {
    font-size: 24px;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.2));
}

/* 配置弹窗遮罩 */
.dh-config-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.dh-config-box {
    background: #fff;
    border-radius: 16px;
    width: min(440px, 92vw);
    box-shadow: 0 20px 60px rgba(0,0,0,0.25);
    overflow: hidden;
}

.dh-config-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
}

.dh-config-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: #1f2937;
}

.dh-config-close {
    background: none;
    border: none;
    font-size: 20px;
    color: #9ca3af;
    cursor: pointer;
    line-height: 1;
    padding: 2px;
    transition: color 0.2s;
}

.dh-config-close:hover { color: #374151; }

.dh-config-body {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.dh-form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dh-form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.dh-form-input {
    width: 100%;
    padding: 10px 14px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.dh-form-input:focus { border-color: #1976D2; }

.dh-ratio-options {
    display: flex;
    gap: 10px;
}

.dh-ratio-option {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s;
}

.dh-ratio-option.active {
    border-color: #1976D2;
    background: #e3f2fd;
    color: #0D47A1;
    font-weight: 600;
}

.dh-ratio-option input { cursor: pointer; }

.dh-init-btn {
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #0D47A1, #1976D2);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s, transform 0.2s;
}

.dh-init-btn:hover:not(:disabled) { transform: translateY(-1px); opacity: 0.92; }
.dh-init-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.dh-error-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    background: #fff2f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    color: #cf1322;
    font-size: 13px;
}

.dh-error-tip .iconify { font-size: 16px; flex-shrink: 0; }

.dh-init-spin {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    flex-shrink: 0;
}

/* 数字人展示弹窗 */
.dh-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0,0,0,0.65);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-modal {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 24px 80px rgba(0,0,0,0.45);
    max-height: 92vh;
}

.dh-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: linear-gradient(135deg, #0D47A1, #1976D2);
    flex-shrink: 0;
}

.dh-modal-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dh-countdown {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 20px;
    padding: 3px 10px;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.5px;
}

.dh-countdown .iconify { font-size: 14px; }

.dh-modal-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dh-modal-avatar {
    width: 34px;
    height: 34px;
    background: rgba(255,255,255,0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
}

.dh-modal-title {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
}

.dh-modal-status {
    font-size: 11px;
    color: rgba(255,255,255,0.8);
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
}

.dh-status-dot {
    width: 6px;
    height: 6px;
    background: #52c41a;
    border-radius: 50%;
    animation: dot-pulse 2s ease-out infinite;
}

@keyframes dot-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(82,196,26,0.4); }
    100% { box-shadow: 0 0 0 5px rgba(82,196,26,0); }
}

.dh-modal-close {
    width: 30px;
    height: 30px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    color: #fff;
    font-size: 16px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.dh-modal-close:hover { background: rgba(255,255,255,0.3); }

.dh-modal-body {
    position: relative;
    overflow: hidden;
    background: #000;
    width: 100%;
    flex-shrink: 0;
}

.dh-iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
}

.dh-loading {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    color: #909399;
    font-size: 13px;
    background: #f5f7fa;
}

.dh-loading-spin {
    width: 36px;
    height: 36px;
    border: 3px solid #e4e7ed;
    border-top-color: #409EFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* 封面遮罩 */
.dh-cover {
    position: absolute;
    inset: 0;
    z-index: 10;
    overflow: hidden;
}

.dh-cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
}

.dh-cover-spin {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 32px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.dh-video-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 10000;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-video-modal {
    position: relative;
    width: min(960px, 92vw);
    aspect-ratio: 16/9;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 24px 80px rgba(0,0,0,0.6);
}

.dh-video-el {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.dh-video-close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    width: 32px;
    height: 32px;
    background: rgba(0,0,0,0.5);
    border: none;
    border-radius: 50%;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dh-video-close:hover { background: rgba(0,0,0,0.8); }

.dh-cover-fade-leave-active {
    transition: opacity 0.6s ease;
}
.dh-cover-fade-leave-to {
    opacity: 0;
}

/* 弹窗动画 */
.modal-fade-enter-active,
.modal-fade-leave-active { transition: opacity 0.22s ease; }
.modal-fade-enter,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter .dh-config-box,
.modal-fade-enter .dh-modal,
.modal-fade-leave-to .dh-config-box,
.modal-fade-leave-to .dh-modal { transform: scale(0.93); }
</style>